import styled from 'styled-components';

export const StyledPageTitle = styled.div`
  display: flex;
  align-items: center;
  padding: 25px 0 25px 8px;
  border-bottom: ${(props) =>
    props.$borderUnderline ? '1px solid var(--color-pale-gray)' : '0px solid transparent'};
  p {
    font-weight: 600;
    font-size: 20px;
    color: var(--color-text-main);
  }

  &.active {
    padding-bottom: 0;
    margin-bottom: 7px;
    border-bottom: 0;
  }
`;
